import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid, Card, CardContent, IconButton, Avatar, Chip, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import PetsIcon from '@mui/icons-material/Pets';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import LanguageIcon from '@mui/icons-material/Language';
import CategoryIcon from '@mui/icons-material/Category';
import EventIcon from '@mui/icons-material/Event';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import EmailIcon from '@mui/icons-material/Email';
import Roadmap from './Roadmap';
import Valutazioni from './Valutazioni';
import PresenzeDinoalunnoView from './PresenzeDinoalunnoView';

import AlunnoSelector from './AlunnoSelector'; // Importa il nuovo componente
import Swal from 'sweetalert2'; // Importa SweetAlert2

import axios from '../axios';

const CourseMTDetailModal = ({ open, onClose, idCorso, refreshCourses }) => {
    const [course, setCourse] = useState(null);
    const [alunni, setAlunni] = useState([]);
    const [roadmaps, setRoadmaps] = useState({});

    const formatDateString = (dateString) => {
        const year = parseInt(dateString.substring(0, 4));
        const month = parseInt(dateString.substring(4, 6)) - 1;
        const day = parseInt(dateString.substring(6, 8));
        return format(new Date(year, month, day), 'dd/MM/yyyy');
    };

    const fetchCourseDetails = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post('/datahandler/corso-alunni-insegnante', {
                idCorso,
                token
            });
            console.log("RESPONSE DATA:", response.data); // 👈 aggiungi questo

            if (response.data.length > 0) {
                setCourse(response.data[0]);
                setAlunni(response.data);
                updateAllRoadmaps(response.data);
                refreshCourses();
            } else {
                console.warn("No course data found for idCorso:", idCorso);
            }
        } catch (error) {
            console.error('Error fetching course details:', error);
        }
    };


    const updateRoadmap = async (idAlunno) => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post('datahandler/corso-alunno-roadmap', {
                idCorso,
                idAlunno,
                token: token
            });
            setRoadmaps(prevRoadmaps => ({
                ...prevRoadmaps,
                [idAlunno]: response.data
            }));
        } catch (error) {
            console.error('Error updating roadmap:', error);
        }
    };

    const updateAllRoadmaps = (alunniData) => {
        alunniData.forEach(alunno => {
            if (alunno.idalunno) {
                updateRoadmap(alunno.idalunno);
            }
        });
    };

    const handleRemoveAlunno = async (idAlunno) => {
        Swal.fire({
            title: 'Sei sicuro?',
            text: "Vuoi davvero rimuovere questo alunno dal corso?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sì, rimuovi',
            cancelButtonText: 'Annulla'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const token = localStorage.getItem('token');
                try {
                    await axios.post('/datahandler/remove-alunno-dal-corso', {
                        idCorso,
                        idAlunno,
                        token: token
                    });
                    fetchCourseDetails(); // Ricarica i dettagli del corso dopo la rimozione
                    Swal.fire(
                        'Rimosso!',
                        'L\'alunno è stato rimosso dal corso.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error removing alunno from corso:', error);
                    Swal.fire(
                        'Errore!',
                        'Si è verificato un errore durante la rimozione dell\'alunno.',
                        'error'
                    );
                }
            }
        });
    };


    const isCourseEnded = () => {
        if (!course) return false;
        const currentDate = new Date();
        const endDate = new Date(
            parseInt(course.data_fine_corso.substring(0, 4)),
            parseInt(course.data_fine_corso.substring(4, 6)) - 1,
            parseInt(course.data_fine_corso.substring(6, 8))
        );
        return currentDate > endDate;
    };

    useEffect(() => {
        if (open) {
            fetchCourseDetails();
        }
    }, [open]);

    useEffect(() => {
        console.log("CourseMTDetailModal useEffect open:", open, "idCorso:", idCorso);
    }, [open, idCorso]);


    if (!course) return null;





    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderRadius: '24px',
                    background: 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(20px) saturate(160%)',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                    border: '1px solid rgba(255,255,255,0.4)',
                    overflow: 'hidden'
                }
            }}
        >
            <DialogTitle sx={{
                p: 0,
                background: 'linear-gradient(135deg, #f57c00 0%, #e65100 100%)',
                color: 'white',
                position: 'relative'
            }}>
                <Box sx={{ p: 3, pb: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: '-0.5px', pr: 5 }}>
                        {course.post_title}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                        <Chip
                            icon={<SchoolIcon sx={{ color: 'white !important', fontSize: 16 }} />}
                            label={`${course.nometeacher} ${course.cognometeacher}`}
                            size="small"
                            sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 600 }}
                        />
                        <Chip
                            icon={<LanguageIcon sx={{ color: 'white !important', fontSize: 16 }} />}
                            label={course.lingua}
                            size="small"
                            sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 600 }}
                        />
                    </Box>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 12,
                        top: 12,
                        color: 'white',
                        bgcolor: 'rgba(0,0,0,0.1)',
                        '&:hover': { bgcolor: 'rgba(0,0,0,0.2)' }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                <Box sx={{
                    bgcolor: 'rgba(0,0,0,0.03)',
                    borderRadius: '16px',
                    p: 2,
                    mb: 4,
                    border: '1px solid rgba(0,0,0,0.05)'
                }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Avatar sx={{ bgcolor: 'rgba(13, 71, 161, 0.1)', color: '#0d47a1', width: 32, height: 32 }}>
                                    <SignalCellularAltIcon fontSize="small" />
                                </Avatar>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Livello</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{course.livello}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Avatar sx={{ bgcolor: 'rgba(0, 151, 167, 0.1)', color: '#0097a7', width: 32, height: 32 }}>
                                    <ChildCareIcon fontSize="small" />
                                </Avatar>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Età</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{course.gruppoeta}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Avatar sx={{ bgcolor: 'rgba(123, 31, 162, 0.1)', color: '#7b1f1f', width: 32, height: 32 }}>
                                    <CategoryIcon fontSize="small" />
                                </Avatar>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Tipo</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{course.course_type}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.5 }}>
                                <Avatar sx={{ bgcolor: 'rgba(25, 118, 210, 0.1)', color: '#1976d2', width: 32, height: 32 }}>
                                    <EventIcon fontSize="small" />
                                </Avatar>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Periodo</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                        {formatDateString(course.data_inizio_corso)} — {formatDateString(course.data_fine_corso)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <AlunnoSelector idCorso={idCorso} onAlunnoAdded={fetchCourseDetails} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 800, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PetsIcon sx={{ color: '#f57c00' }} />
                    DinoAlunni Iscritti
                </Typography>

                <Box>
                    {alunni.length > 0 && alunni[0].idalunno ? (
                        alunni.map((alunno) => (
                            <Card
                                key={alunno.idalunno}
                                className="glass-course-card"
                                sx={{
                                    marginBottom: 3,
                                    background: 'rgba(255, 255, 255, 0.5)',
                                    overflow: 'visible'
                                }}
                            >
                                <CardContent sx={{ p: 2.5 }}>
                                    <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
                                        <Grid item>
                                            <Avatar sx={{ bgcolor: 'rgba(255, 152, 0, 0.15)', color: '#e65100', width: 48, height: 48 }}>
                                                <PersonIcon fontSize="medium" />
                                            </Avatar>
                                        </Grid>
                                        <Grid item xs>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#2c3e50' }}>
                                                {`${alunno.nome} ${alunno.cognome}`}
                                            </Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#666' }}>
                                                <EmailIcon sx={{ fontSize: 14 }} />
                                                <Typography variant="caption" sx={{ fontWeight: 600 }}>{alunno.email}</Typography>
                                            </Box>
                                        </Grid>
                                        {!isCourseEnded() && (
                                            <Grid item>
                                                <Tooltip title="Rimuovi dal corso">
                                                    <IconButton
                                                        onClick={() => handleRemoveAlunno(alunno.idalunno)}
                                                        sx={{
                                                            bgcolor: 'rgba(211, 47, 47, 0.05)',
                                                            color: '#d32f2f',
                                                            '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.15)' }
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        )}
                                    </Grid>

                                    <Box sx={{ borderTop: '1px dashed rgba(0,0,0,0.1)', pt: 2, mt: 2 }}>
                                        <PresenzeDinoalunnoView idCorso={idCorso} idAlunno={alunno.idalunno} />
                                        <Roadmap
                                            idCorso={idCorso}
                                            idAlunno={alunno.idalunno}
                                            dataInizioCorso={course.data_inizio_corso}
                                            nomeAlunno={alunno.nome}
                                            cognomeAlunno={alunno.cognome}
                                            roadmap={roadmaps[alunno.idalunno] || []}
                                            updateAllRoadmaps={fetchCourseDetails}
                                            updateRoadmap={updateRoadmap}
                                        />
                                        <Valutazioni idAlunno={alunno.idalunno} />
                                    </Box>
                                </CardContent>
                            </Card>
                        ))
                    ) : (
                        <Box sx={{ textAlign: 'center', py: 6, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: '16px', border: '1px dashed rgba(0,0,0,0.1)' }}>
                            <PetsIcon sx={{ fontSize: 48, color: '#ccc', mb: 2 }} />
                            <Typography variant="h6" color="text.secondary">Nessun alunno associato.</Typography>
                        </Box>
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, bgcolor: 'rgba(0,0,0,0.02)' }}>
                <Button
                    variant="contained"
                    onClick={onClose}
                    className="btn-3d btn-3d-grey"
                    sx={{ px: 4 }}
                >
                    Chiudi
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CourseMTDetailModal;
